<template>
    <Modal
        class="DeleteGroup"
        :opened="isOpen"
        :title="'Delete Group'"
        :dissmisable="true"
        @close="closeModal"
    >
        <template #body>
            <div class="DeleteGroupBody">
                <WText
                    :size="16"
                    color="gray01"
                >
                    {{ $t('schema.groups.deleteAdvice', { groupName: group.name }) }}
                </WText>
                <div
                    v-if="shouldTransferFields"
                    class="ChangeGroup"
                >
                    <WText
                        :size="16"
                        color="gray01"
                    >
                        {{ $t('schema.groups.transferAdvice', { groupName: group.name }) }}
                    </WText>
                    <WSelect
                        v-model="changeGroupBy"
                        :options="changeGroupOptions"
                        :placeholder="$t('schema.groups.selectTransferGroup')"
                        name="changeGroupBy"
                        class="ChangeGroupSelect"
                    />
                </div>
                <div
                    v-if="deleting"
                    class="DeleteGroupActions"
                >
                    <WText
                        :size="16"
                        color="accent-blue"
                        weight="bold"
                        class="Deleting"
                    >
                        {{ $t('schema.groups.deleting') }}
                    </WText>
                </div>
                <div
                    v-else
                    class="DeleteGroupActions"
                >
                    <WButton
                        outline
                        color="accent-blue"
                        @click="closeModal"
                    >
                        {{ $t('schema.groups.cancel') }}
                    </WButton>
                    <WButton
                        :disabled="deleteDisabled"
                        @click="deleteGroup"
                    >
                        {{ $t('schema.groups.delete') }}
                    </WButton>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import VueTypes from 'vue-types'
import { Api, apiRequest } from '@/api'
import { Modal } from '@/components'

export default {
    name: 'DeleteGroupModal',
    components: { Modal },
    props: {
        isOpen: VueTypes.bool,
        group: VueTypes.object,
        groups: VueTypes.array,
        fields: VueTypes.array,
        entityKey: VueTypes.string,
    },
    data () {
        return {
            changeGroupBy: '',
            deleting: false,
        }
    },
    computed: {
        changeGroupOptions () {
            return this.groups.filter(group => group.key !== this.group.key).map(group => ({
                key: group.key,
                label: group.name,
            }))
        },
        shouldTransferFields () {
            return this.fields.some(field => field.groupKey === this.group.key)
        },
        deleteDisabled () {
            return this.shouldTransferFields && !this.changeGroupBy
        },
    },
    methods: {
        closeModal () {
            this.changeGroupBy = ''
            this.$emit('close')
        },
        deleteGroup () {
            this.deleting = true
            const { entityKey, group, changeGroupBy } = this
            apiRequest(Api().entities.deleteGroup({ entityKey, groupKey: group.key, changeGroupBy }))
                .then(() => {
                    this.$emit('refreshGroups')
                    this.closeModal()
                })
                .finally(() => { this.deleting = false })
        },
    },
}
</script>

<style lang="scss" scoped>
.DeleteGroup {
    &::v-deep .Dialog {
        overflow: visible;
    }
    .DeleteGroupBody {
        .ChangeGroup {
            margin-top: 15px;
            margin-bottom: 15px;
            .ChangeGroupSelect {
                margin-top: 10px
            }
        }
        .DeleteGroupActions {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            margin-top: 30px;
            .Deleting {
                padding-top: 7px;
                padding-bottom: 7px;
            }
        }
    }
}
</style>
